"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcFooterBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_footer_constants_1 = require("./bc-footer-constants");
var bc_accordion_behavior_1 = require("../../molecules/bc-accordion/bc-accordion-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var BcFooterBehavior = (function (_super) {
    __extends(BcFooterBehavior, _super);
    function BcFooterBehavior() {
        return _super.call(this) || this;
    }
    BcFooterBehavior.setUpAll = function () {
        var inputElements = Array.from(document.querySelectorAll("div[class~='".concat(bc_footer_constants_1.BcFooterConstants.BC_FOOTER, "']")));
        var elements = [];
        for (var _i = 0, inputElements_1 = inputElements; _i < inputElements_1.length; _i++) {
            var inputElement = inputElements_1[_i];
            var bcFooterBehavior = new BcFooterBehavior();
            bcFooterBehavior.setElement(inputElement);
            bcFooterBehavior.setUp();
            elements.push(bcFooterBehavior);
        }
        return elements;
    };
    BcFooterBehavior.prototype._setUp = function () {
        this._validateBreakPointMobile();
        this._addResizeListener();
    };
    BcFooterBehavior.prototype._getFooterTopELements = function () {
        return Array.from(this.mySelf.querySelectorAll("div[class~='".concat(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_TOP_CONTAINERS, "']")));
    };
    BcFooterBehavior.prototype._isMobileWidth = function () {
        if (window.innerWidth <= bc_footer_constants_1.BcFooterConstants.BC_FOOTER_MD_TABLET) {
            return true;
        }
        return false;
    };
    BcFooterBehavior.prototype._validateBreakPointMobile = function () {
        if (this._isMobileWidth()) {
            this._configureAccordion();
        }
    };
    BcFooterBehavior.prototype._addResizeListener = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_RESIZE, function () {
            _this._validateBreakPointMobile();
        });
    };
    BcFooterBehavior.prototype._generateId = function (componentType) {
        var array = new Uint32Array(1);
        var randomNumber = window.crypto.getRandomValues(array);
        return "".concat(componentType, "-").concat(randomNumber[0]);
    };
    BcFooterBehavior.prototype._existsAccordion = function () {
        var mobileContainer = this.mySelf.querySelector(".".concat(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_COLUMN_LINKS_MOBILE));
        return mobileContainer !== null;
    };
    BcFooterBehavior.prototype._configureAccordion = function () {
        var _this = this;
        if (!this._existsAccordion()) {
            var columnLinks_1 = this._getFooterTopELements();
            var containerColumnLinks = this.mySelf.querySelector(".".concat(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_TOP));
            if (containerColumnLinks && columnLinks_1.length > 0) {
                var containerMobile = document.createElement('div');
                containerMobile.classList.add(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_COLUMN_LINKS_MOBILE);
                containerColumnLinks.after(containerMobile);
                var _a = this._createAccordionGroupELement(), accordionGroupElement_1 = _a[0], idFooterAccordion = _a[1];
                columnLinks_1.forEach(function (element, index) {
                    var textTitleList = element.querySelector(".".concat(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_TOP_CONTAINER_TITLE, " h6"));
                    var textItemsList = Array.from(element.querySelectorAll(".".concat(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_TOP_CONTAINER_CONTENT, " a")));
                    var accordionElement = _this._createAccordionELement();
                    var accordionHeaderElement = _this._createAccordionHeaderELement(textTitleList);
                    var accordionContentElement = _this._createAccordionContentELement(textItemsList);
                    accordionElement.appendChild(accordionHeaderElement);
                    accordionElement.appendChild(accordionContentElement);
                    accordionGroupElement_1.appendChild(accordionElement);
                    if (_this._addDivider(columnLinks_1.length, index)) {
                        accordionGroupElement_1.appendChild(_this._createDivider());
                    }
                });
                containerMobile.appendChild(accordionGroupElement_1);
                this._setupAccordion(idFooterAccordion);
                this._configureAccordionHeader();
            }
        }
    };
    BcFooterBehavior.prototype._setupAccordion = function (idAccordion) {
        var accordionHTML = this.mySelf.querySelector("#".concat(idAccordion));
        var accordion = new bc_accordion_behavior_1.BcAccordionBehavior();
        accordion.setElement(accordionHTML);
        accordion.setUp();
    };
    BcFooterBehavior.prototype._configureAccordionHeader = function () {
        var headers = this.mySelf.querySelectorAll("header");
        headers.forEach(function (element) {
            element.setAttribute('aria-expanded', 'true');
        });
    };
    BcFooterBehavior.prototype._addDivider = function (columnLength, index) {
        var lastColumn = index === columnLength - 1;
        var containerAdditionLinks = this.mySelf.querySelector(".".concat(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_TOP_LINKS));
        if (lastColumn && !containerAdditionLinks) {
            return false;
        }
        return true;
    };
    BcFooterBehavior.prototype._createDivider = function () {
        var divDivider = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divDivider.classList.add(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_DIVIDER);
        return divDivider;
    };
    BcFooterBehavior.prototype._createAccordionGroupELement = function () {
        var accordionGroupElement = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        accordionGroupElement.classList.add(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_ACCORDIONS_GROUP);
        var idFooterAccordion = this._generateId(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_ACCORDION_PREFIX);
        accordionGroupElement.setAttribute('id', idFooterAccordion);
        return [accordionGroupElement, idFooterAccordion];
    };
    BcFooterBehavior.prototype._createAccordionELement = function () {
        var accordionElement = document.createElement(common_constants_1.BcCommonConstants.ARTICLE_TAG);
        accordionElement.classList.add(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_ACCORDION);
        accordionElement.classList.add(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_ACCORDION_TYPE);
        accordionElement.classList.add('bc-active');
        var idAccordion = this._generateId(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_ACCORDION);
        accordionElement.setAttribute('id', idAccordion);
        return accordionElement;
    };
    BcFooterBehavior.prototype._createSectionLeft = function (titleHeader) {
        var sectionLeft = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        sectionLeft.classList.add(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_ACCORDION_HEADER_LEFT);
        var sectionContent = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        sectionContent.classList.add(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_ACCORDION_TEXT_CONTAINER);
        sectionContent.append(titleHeader.cloneNode(true));
        var idTextContainer = this._generateId(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_ACCORDION_HEADER_TITLE);
        sectionContent.setAttribute('id', idTextContainer);
        sectionLeft.appendChild(sectionContent);
        return sectionLeft;
    };
    BcFooterBehavior.prototype._createSectionRight = function () {
        var _a;
        var arrowRight = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        arrowRight.classList.add(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_ACCORDION_HEADER_RIGHT);
        var bcIcon = document.createElement('em');
        (_a = bcIcon.classList).add.apply(_a, bc_footer_constants_1.BcFooterConstants.BC_ICON_CLASSES);
        bcIcon.textContent = bc_footer_constants_1.BcFooterConstants.BC_FOOTER_ACCORDION_ARROW;
        arrowRight.appendChild(bcIcon);
        return arrowRight;
    };
    BcFooterBehavior.prototype._createAccordionHeaderELement = function (titleHeader) {
        var accordionHeaderElement = document.createElement('header');
        var sectionLeft = this._createSectionLeft(titleHeader);
        accordionHeaderElement.appendChild(sectionLeft);
        accordionHeaderElement.appendChild(this._createSectionRight());
        return accordionHeaderElement;
    };
    BcFooterBehavior.prototype._createAccordionContentELement = function (items) {
        var accordionContentElement = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        accordionContentElement.classList.add(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_ACCORDION_CONTENT);
        items.forEach(function (item) {
            accordionContentElement.appendChild(item.cloneNode(true));
        });
        return accordionContentElement;
    };
    BcFooterBehavior.prototype.createParameterizationStrokeColors = function (colors) {
        var svg = this.mySelf.querySelector("#".concat(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_STROKE));
        if (svg) {
            for (var propiedad in colors) {
                var pathElement = svg.querySelector('#' + propiedad);
                pathElement.setAttribute('fill', colors[propiedad]);
            }
        }
    };
    BcFooterBehavior.prototype.updateAccordion = function () {
        var linksMobile = this.getMySelf().querySelector(".".concat(bc_footer_constants_1.BcFooterConstants.BC_FOOTER_COLUMN_LINKS_MOBILE));
        if (linksMobile) {
            linksMobile.remove();
            this._validateBreakPointMobile();
        }
    };
    return BcFooterBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcFooterBehavior = BcFooterBehavior;
